import React from 'react';
import { Route } from "react-router-dom";

import Application from './AppMainList';
import NotFound from '../utils/NotFound';
import Loading from '../utils/Loading';

const Guarded = (allowedUrl: any, { ...rest }) => {

    return (
        <Route {...rest} render={(props) => (
            allowedUrl.allowedUrl.length > 0 ?
                allowedUrl.allowedUrl.find((e: { LINK: string; }) => e.LINK == window.location.pathname) || window.location.pathname === '/' ?
                    <Application {...props}></Application>
                    :
                    <NotFound></NotFound>
                :
                <Loading></Loading>

        )} />
    )

}

export default Guarded;